import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import rrulePlugin from '@fullcalendar/rrule';
import formatISO from 'date-fns/formatISO';
import parseISO from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';

const addDay = (dateStr) => formatISO(addDays(parseISO(dateStr), 1), { representation: 'date' });

export function initCalendar(calendarEl) {
    const data = JSON.parse(document.getElementById('whatson-calendar-data').innerHTML);

    const calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin, bootstrapPlugin, listPlugin, rrulePlugin],
        themeSystem: 'bootstrap',
        initialView: window.innerWidth <= 800 ? 'listMonth' : 'dayGridMonth',
        bootstrapFontAwesome: {
            prev: 'fa-arrow-left',
            next: 'fa-arrow-right'
        },
        views: {
            dayGridMonth: { buttonText: 'Grid' },
            listMonth: { buttonText: 'List' }
        },
        events: data.map(event => {
            const returnEvent = {
                title: event.Title,
                extendedProps: {
                    id: event.ID
                },
                imageurl: 'img/edit.png'
            };
            if (event.Recurring) {
                returnEvent.rrule = {
                    freq: event.RecurringFrequency,
                    interval: 1,
                    dtstart: event.StartDate,
                    until: event.EndDate

                };
            } else {
                returnEvent.start = event.StartDate;
                if (event.EndDate) {
                    returnEvent.end = addDay(event.EndDate);
                }
            }
            return returnEvent;
        }),
        eventClick: function(info) {
            const id = info.event.extendedProps.id;
            $('#calendar-modal-' + id).modal('show');
        },
        eventColor: '#fff',
    });
    calendar.render();
}
